import axios from "@/utils/axios";

const API_URL = process.env.VUE_APP_API_URL || "";

export const fetchServiceCategories = async () => {
  const response = await axios.get(`${API_URL}/service-categories`);
  return response.data?.data ?? response.data;
};

export const createServiceCategory = async (payload) => {
  const response = await axios.post(`${API_URL}/service-categories`, payload);
  return response.data;
};

export const updateServiceCategory = async (id, payload) => {
  const response = await axios.put(`${API_URL}/service-categories/${id}`, payload);
  return response.data;
};

export const deleteServiceCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/service-categories/${id}`);
  return response.data;
};
